// extracted by mini-css-extract-plugin
export default {"main":"RC-QY","label":"_4RwRq"};